import React from "react";
import List from "../ui/List";

export default function ReportList({ reports }) {
  return <List data={reports} role="directorate-report" />;
}
